import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './ToggleButton.module.scss';
import { Icon } from '../Icon/Icon';
import { useKeyboardClick } from '../../hooks/useKeyboardClick';

export interface ToggleButtonProps {
    opened: boolean;
    secondary?: boolean;
    className?: string;
    onClick?: () => void;
    ariaLabel?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const ToggleButton = ({
    opened,
    secondary,
    className,
    onClick,
    ariaLabel,
    ...props
}: ToggleButtonProps): ReactElement | null => {
    const handleKeyDown = useKeyboardClick(onClick || noop);

    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={handleKeyDown}
            className={cn(styles.wrapper, opened && styles.opened, secondary && styles.secondary, className)}
            aria-label={ariaLabel ?? (opened ? 'Zavřít postup' : 'Zobrazit postup')}
            aria-expanded={opened}
            {...props}
        >
            <div className={styles.icon}>
                <Icon size="small" name="next" />
            </div>
        </div>
    );
};
